import { render } from "./RefreshIcon.vue?vue&type=template&id=39677e06"
const script = {}

import exportComponent from "/home/tabelka-front/tabelka.expansja.pl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__